import request from "./request";

export function getManageApplicationsAPI() {
    return request('/api/applications', { method: 'GET' });
}
